import { freddyTheme, type SxProps } from '@coolblue-development/freddy';

export const styledButtonStyles: SxProps = {
  borderColor: freddyTheme.color.border.base,
  boxShadow: 'initial',
  padding: freddyTheme.spacing[200],
  height: freddyTheme.spacing[1000],
  width: '100%',
  justifyContent: 'space-between',
  svg: {
    width: freddyTheme.spacing[300],
    height: freddyTheme.spacing[300]
  },
  ':hover': {
    borderColor: freddyTheme.color.border.base,
    boxShadow: freddyTheme.shadow.subtle
  },
  p: {
    textAlign: 'start',
    paddingLeft: freddyTheme.spacing[100]
  }
};
